import { render } from "./TaxAccountingEntryInfosModal.vue?vue&type=template&id=f87af834&scoped=true&ts=true&lang=pug"
import script from "./TaxAccountingEntryInfosModal.vue?vue&type=script&lang=ts"
export * from "./TaxAccountingEntryInfosModal.vue?vue&type=script&lang=ts"

import "./TaxAccountingEntryInfosModal.vue?vue&type=style&index=0&id=f87af834&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87af834"]])

export default __exports__